export const HEROES_URL = '/assets/images/heroes/';
export const CORRECT_HEROES_URL = HEROES_URL + 'positive/';
export const WRONG_HEROES_URL = HEROES_URL + 'negative/';

export const HEROES = [
  HEROES_URL + 'panda_1.png',
  HEROES_URL + 'sloth.png',
  HEROES_URL + 'turtle.png',
  HEROES_URL + 'ulitka1.png',
  HEROES_URL + 'matrix.png',
  HEROES_URL + 'kenguru_2.png',
];

export const CORRECT_HEROES = [
  CORRECT_HEROES_URL + 'IMG_6496.png',
  CORRECT_HEROES_URL + 'IMG_6504.png',
  CORRECT_HEROES_URL + 'IMG_6506.png',
  CORRECT_HEROES_URL + 'IMG_6508.png',
  CORRECT_HEROES_URL + 'IMG_6509.png',
  CORRECT_HEROES_URL + 'IMG_6511.png',
  CORRECT_HEROES_URL + 'IMG_6513.png',
  CORRECT_HEROES_URL + 'IMG_6516.png',
  CORRECT_HEROES_URL + 'IMG_6518.png',
  CORRECT_HEROES_URL + 'IMG_7211.png',
];

export const WRONG_HEROES = [
  WRONG_HEROES_URL + 'IMG_6890.png',
  WRONG_HEROES_URL + 'IMG_6892.png',
  WRONG_HEROES_URL + 'IMG_6894.png',
  WRONG_HEROES_URL + 'IMG_6899.png',
  WRONG_HEROES_URL + 'IMG_6900.png',
  WRONG_HEROES_URL + 'IMG_6902.png',
  WRONG_HEROES_URL + 'IMG_6904.png',
  WRONG_HEROES_URL + 'IMG_6906.png',
  WRONG_HEROES_URL + 'IMG_6908.png',
  WRONG_HEROES_URL + 'IMG_7207.png',
];
